import { Code as CodeBlock } from './/code.ripple';
import { Card } from './ui/card.ripple';
import { getComponentCode } from '../lib/get-component-code';
import { track } from 'ripple';

export component Usage({ id }: { id: string }) {
	const code = track(() => getComponentCode(id));

	<section class='mb-12' data-id="usage">
		<h2 class='text-2xl font-bold mb-4'>{'Usage'}</h2>
		<Card class='p-6 bg-muted/50'><CodeBlock code={@code} language='jsx' /></Card>
	</section>
}